import { useCallback, useEffect, useState } from 'react'
import { IDLE, enqueueCall, wakeCall, wakeDelay, type QueueRules, type TakeoverCall, type TakeoverState } from './callPage'

/** The call queue (lib/callPage.ts) with its timer: the state, and a way to add a call. */
export function useCallQueue(seconds: number, rules: QueueRules): [TakeoverState, (call: TakeoverCall) => void] {
  const [state, setState] = useState<TakeoverState>(IDLE)
  // The timer's firing always moves the page on (wakeCall), never later than a full hold (wakeDelay).
  useEffect(() => {
    const delay = wakeDelay(state, seconds, Date.now(), rules)
    const armedFor = state.showing?.key
    if (delay === null || !armedFor) return
    const timer = window.setTimeout(() => setState((s) => wakeCall(s, armedFor, Date.now(), seconds, rules)), delay)
    return () => window.clearTimeout(timer)
  }, [state, seconds, rules])
  const enqueue = useCallback(
    (call: TakeoverCall) => setState((s) => enqueueCall(s, call, Date.now(), seconds, rules)),
    [seconds, rules],
  )
  return [state, enqueue]
}
